import * as helper from './../../../../../VX/View/Assets/Js/helper';

export default class SectionHandler {
	constructor() {
		this.container = helper.$('#content');
		this.sections = helper.$('#content > .container');
		this.active = 0;
		this.setFlex();
	}

	next() {
		helper.addClass(this.sections[this.active], 'done');
		this.active++;
		helper.removeClass(this.sections[this.active], 'upcoming');
		this.setFlex();
	}

	previous() {
		helper.addClass(this.sections[this.active], 'upcoming');
		this.active--;
		helper.removeClass(this.sections[this.active], 'done');
		this.setFlex();
	}

	setFlex() {
		this.container.style.flex = '0 1 ' + (this.sections[this.active].clientHeight + 10) + 'px';
	}
}
